import { IntroSubContent } from "../components/pages/intro/intro.model"
import { Injectable } from "@angular/core"

@Injectable({
  providedIn: "root",
})
export class BaltimoreMdRegion {

  localVideo(): IntroSubContent {
    return {
      image: {
        altText: "Baltimore logo",
        srcDarkMode: "",
        srcLightMode: "",
        style: {},
      },
      video: {},
      style: {},
      contents: [],
      subTitle: "",
      value: "",
    }
  }

  brandHeader(): IntroSubContent {
    return {
      contents: [],
      video: {},
      title: "Baltimore",
      subTitle: "presented in partnership with",
      image: {
        altText: "T.RowePrice Foundation",
        srcDarkMode: "/assets/regions/baltimore_md/trowpricefoundation.png",
        srcLightMode: "/assets/regions/baltimore_md/trowpricefoundation.png",
        style: {},
      },
      style: {
        width: "300px",
      },
    }
  }

  regionProperties() {
    return {"area_id":2868,"city_id":68,"grade":"D","fill":"#d9838d","label":"D1","name":" ","category_id":4,"sheets":1,"area":0.000499993985818227,"bounds":[[39.28491,-76.60986],[39.31207,-76.58423]],"label_coords":[39.296,-76.596],"residential":true,"commercial":false,"industrial":false,"city":"Baltimore","state":"MD","form_id":19370601,"name_of_city":"Baltimore","security_grade":"D","area_number":"1","description_of_terrain":"Level to undulating","favorable_influences":"Proximity to employment, industrial and commercial","detrimental_influences":"Heavy concentration of foreigners. Property is in very bad state of repair.","occupation_or_type":"Laborers","estimated_annual_family_income":"1000","foreign_born_nationality":"Italians","foreign_born_percent":"25","negro_yes_or_no":"Yes","negro_percent":"25","infiltration_of":"Negro","relief_families":"Yes","population_increasing":"","population_decreasing":"Fast","buildings_type":"3 story row","construction":"Brick","average_age":"65 years","repair":"poor","price_range_dollars_1929":"1,500-3,500","price_predominating_1929":"2,500","rent_range_dollars_1929":"20-30","rent_predominating_1929":"25","middle_year":"1933-35","price_range_dollars_middle_year":"800-2,200","price_predominating_dollars_middle_year":"1,700","price_range_percent_middle_year":"53-63","rent_range_middle_year":"12-20","rent_predominating_middle_year":"15","rent_range_percent_middle_year":"60-67","last_year":"May, 1937","price_range_dollars_last_year":"800-2,200","price_predominating_dollars_last_year":"1,700","price_range_percent_last_year":"53-63","rent_range_last_year":"15-25","rent_predominating_last_year":"20","rent_range_percent_last_year":"75-83","peak_sales_year":"1929","peak_sales_percent":"100","peak_rental_year":"1929","peak_rental_percent":"100","occupancy":"100","dwelling_units":"90","home_ownership":"35-40","sales_demand_characterization":"poor","sales_demand_amount":"","sales_demand_activity":"poor","rental_demand_characterization":"poor","rental_demand_amount":"","rental_demand_activity":"fair","new_construction_types":"none","new_construction_amount_last_year":"none","availability_of_mortgage_funds_home_purchase":"no","availability_of_mortgage_funds_home_building":"no","trend_of_desirability":"Downward","clarifying_remarks":"Ground rents in this section range from $36 to 60. Average $42. Properties around Johns Hopkins Hospital are better than the average and have considerable desirability in housing hospital attendants and for commercial value Ground rents on broadway. Sales are very property. Section east of broadway is better. southern section largely industry. Whole section is spotty.","information_obtained_from":"","information_obtained_month_and_day":"May-37","information_obtained_193x":"","selected_fields":"Ground rents in this section range from $36 to 60. Average $42. Properties around Johns Hopkins Hospital are better than the average and have considerable desirability in housing hospital attendants and for commercial value Ground rents on broadway. Sales are very property. Section east of broadway is better. southern section largely industry. Whole section is spotty. Level to undulating Proximity to employment, industrial and commercial Heavy concentration of foreigners. Property is in very bad state of repair. Laborers Italians Yes Negro","all_fields":"Baltimore D 1 Level to undulating Proximity to employment, industrial and commercial Heavy concentration of foreigners. Property is in very bad state of repair. Laborers 1000 Italians 25 Yes 25 Negro Yes  Fast 3 story row Brick 65 years poor 1,500-3,500 2,500 20-30 25 1933-35 800-2,200 1,700 53-63 12-20 15 60-67 May, 1937 800-2,200 1,700 53-63 15-25 20 75-83 1929 100 1929 100 100 90 35-40 poor  poor poor  fair none none no no Downward Ground rents in this section range from $36 to 60. Average $42. Properties around Johns Hopkins Hospital are better than the average and have considerable desirability in housing hospital attendants and for commercial value Ground rents on broadway. Sales are very property. Section east of broadway is better. southern section largely industry. Whole section is spotty.  May-37 "}
  }

/*
  regionProperties() {
    return {
      all_fields: "Baltimore D 9 Level to undulating Central location. Conversion value for business expansion. Heavy obsolescence of residential property. Business noises. mixture  mixture 11.4 Yes 40.2 all lower classes Quite a few  Fast 2 & 3 story row Brick 60 years poor to fair 1,200-3,000  20-50  1933-35 400-1,000   12-25   May, 1937 800-2,000   15-30   1929 100 1929 100 100 83 15 poor  poor poor  poor none None   Residential downward; commercial upward Most of this section comprises the commercial area of the city. Houses are intermingled with business. Ground rents range from $30-90. Average $60. Alley property is very bad. Louis Kroner, property review appraiser H.O.L.C. 4-May-37 ",
      area: 0.000179632803549756,
      area_id: 7275,
      area_number: "9",
      availability_of_mortgage_funds_home_building: "",
      availability_of_mortgage_funds_home_purchase: "",
      average_age: "60 years",
      bounds: [[39.28588,-76.62724],[39.29578,-76.6051]],
      buildings_type: "2 & 3 story row",
      category_id: 4,
      city: "Baltimore",
      city_id: 68,
      clarifying_remarks: "Most of this section comprises the commercial area of the city. Houses are intermingled with business. Ground rents range from $30-90. Average $60. Alley property is very bad.",
      commercial: false,
      construction: "Brick",
      description_of_terrain: "Level to undulating",
      detrimental_influences: "Heavy obsolescence of residential property. Business noises.",
      dwelling_units: "83",
      estimated_annual_family_income: "",
      favorable_influences: "Central location. Conversion value for business expansion.",
      fill: "#d9838d",
      foreign_born_nationality: "mixture",
      foreign_born_percent: "11.4",
      form_id: 19370601,
      grade: "D",
      home_ownership: "15",
      industrial: false,
      infiltration_of: "all lower classes",
      information_obtained_193x: "",
      information_obtained_from: "Louis Kroner, property review appraiser H.O.L.C.",
      information_obtained_month_and_day: "4-May-37",
      label: "D9",
      label_coords: [39.291,-76.613],
      last_year: "May, 1937",
      middle_year: "1933-35",
      name: " ",
      name_of_city: "Baltimore",
      negro_percent: "40.2",
      negro_yes_or_no: "Yes",
      new_construction_amount_last_year: "None",
      new_construction_types: "none",
      occupancy: "100",
      occupation_or_type: "mixture",
      peak_rental_percent: "100",
      peak_rental_year: "1929",
      peak_sales_percent: "100",
      peak_sales_year: "1929",
      population_decreasing: "Fast",
      population_increasing: "",
      price_predominating_1929: "",
      price_predominating_dollars_last_year: "",
      price_predominating_dollars_middle_year: "",
      price_range_dollars_1929: "1,200-3,000",
      price_range_dollars_last_year: "800-2,000",
      price_range_dollars_middle_year: "400-1,000",
      price_range_percent_last_year: "",
      price_range_percent_middle_year: "",
      relief_families: "Quite a few",
      rent_predominating_1929: "",
      rent_predominating_last_year: "",
      rent_predominating_middle_year: "",
      rent_range_dollars_1929: "20-50",
      rent_range_last_year: "15-30",
      rent_range_middle_year: "12-25",
      rent_range_percent_last_year: "",
      rent_range_percent_middle_year: "",
      rental_demand_activity: "poor",
      rental_demand_amount: "",
      rental_demand_characterization: "poor",
      repair: "poor to fair",
      residential: true,
      sales_demand_activity: "poor",
      sales_demand_amount: "",
      sales_demand_characterization: "poor",
      security_grade: "D",
      selected_fields: "Most of this section comprises the commercial area of the city. Houses are intermingled with business. Ground rents range from $30-90. Average $60. Alley property is very bad. Level to undulating Central location. Conversion value for business expansion. Heavy obsolescence of residential property. Business noises. mixture mixture Yes all lower classes",
      sheets: 1,
      state: "MD",
      trend_of_desirability: "Residential downward; commercial upward",
    }
  }
*/

}
